import * as React from 'react';
import type { FeaturedProduct } from '../../types/landing';

interface OngProductsProps {
  products: FeaturedProduct[];
}

export function OngProducts({ products }: OngProductsProps) {
  if (products.length === 0) return null;

  return (
    <section className="ong-products">
      <style>{`
        .ong-products {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .ong-products-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .ong-products h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .ong-products .subtitle {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 36px;
        }
        .ong-products-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }
        .ong-product-card {
          background: #fff;
          border-radius: 12px;
          border: 1px solid #eee;
          overflow: hidden;
          transition: box-shadow 0.2s;
        }
        .ong-product-card:hover {
          box-shadow: 0 4px 16px rgba(0,0,0,0.08);
        }
        .ong-product-img {
          width: 100%;
          height: 160px;
          object-fit: cover;
          display: block;
          background: #f5f5f5;
        }
        .ong-product-body {
          padding: 14px 16px;
        }
        .ong-product-cat {
          font-size: 12px;
          color: #1EAA25;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          margin: 0 0 4px;
        }
        .ong-product-name {
          font-size: 15px;
          font-weight: 600;
          color: #1a1a1a;
          margin: 0 0 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .ong-product-format {
          font-size: 13px;
          color: #888;
        }
        @media (max-width: 768px) {
          .ong-products-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
          }
          .ong-product-img {
            height: 120px;
          }
        }
        @media (max-width: 480px) {
          .ong-products-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>
      <div className="ong-products-inner">
        <h2>Productos destacados</h2>
        <p className="subtitle">Algunos de los productos que más eligen las organizaciones sociales</p>
        <div className="ong-products-grid">
          {products.map((product) => (
            <div key={product.id} className="ong-product-card">
              <img
                className="ong-product-img"
                src={product.webp_image_url || product.image_url}
                alt={product.title}
                loading="lazy"
              />
              <div className="ong-product-body">
                <div className="ong-product-cat">{product.category_name}</div>
                <div className="ong-product-name">{product.title}</div>
                {product.default_format && (
                  <div className="ong-product-format">
                    {product.default_format.short_name || product.default_format.name}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
